export default __webpack_public_path__ + "static/B0310-f320ef048d39f6b7b3b8d8a36c9f9415.png";